import useNotes from "@/src/notes/hooks/useNotes";
import { NoteType } from "@/src/notes/types/NoteType";
import { FlagIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";

type ReportButtonProps = {
  note: NoteType;
  disabled: boolean;
  onReport?: () => void;
};

const ReportButton = ({
  note,
  disabled = false,
  onReport,
}: ReportButtonProps) => {
  const { reportNote, unreportNote } = useNotes({
    elementId: note.elementId,
  });

  const handleClick = async () => {
    const reportResponse = await reportNote(note.uid, {
      optimisticData: (currentData) => {
        if (!currentData) {
          return [note.uid];
        }
        return [...currentData, note.uid];
      },
      rollbackOnError: true,
    });

    onReport();

    alert(
      "Thanks for reporting this note. The Mob team will review it shortly."
    );
  };

  return (
    <button
      className={clsx(
        "group flex items-center space-x-1 text-sm font-normal text-zinc-500 transition ease-out hover:text-zinc-950",
        {
          "pointer-events-none": disabled,
        }
      )}
      onClick={handleClick}
      disabled={disabled}
      aria-label="Report note"
    >
      <div>
        <FlagIcon
          className={clsx(
            "size-4 transition ease-out group-hover:fill-zinc-200",
            {}
          )}
        />
      </div>
    </button>
  );
};

export default ReportButton;
